// extracted by mini-css-extract-plugin
export default {"UrlMenu_Link":"UrlMenu_Link2J9tjNIuzPZm"};